import Main from './components/Main/Main'
import About from './components/About/About'
import Skill from './components/Skill/Skill'
import Jobs from './components/Jobs/Jobs'
import Portfolio from './components/Portfolio/Portfolio'
import Contato from './components/Contato/Contato'
import Footer from './components/Footer/Footer'

function App() {
  return (
    <div className="App">

      <Main />
      <About />
      <Skill />
      <Jobs />
      <Portfolio />
      <Contato />
      <Footer />
      
    </div>
  );
}

export default App;
